module.exports = __webpack_public_path__ + "static/media/story-6.5f5ec2b7.jpg";